import React, { useState } from 'react';
import { DataTable } from '../components/DataTable';
import { WizardForm } from '../components/WizardForm';
import { StatusBadge } from '../components/StatusBadge';
export function GuideManagement() {
  const [activeTab, setActiveTab] = useState<'list' | 'add'>('list');
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({
    photo: '',
    fullName: '',
    fatherName: '',
    spouseName: '',
    nid: '',
    birthCertNo: '',
    profession: '',
    age: '',
    education: '',
    division: '',
    district: '',
    upazila: '',
    union: '',
    village: '',
    range: '',
    station: '',
    bloodGroup: '',
    organization: '',
    nidAttachment: '',
    birthCertAttachment: '',
    educationAttachment: ''
  });
  const stationsByRange: Record<string, string[]> = {
    Satkhira: ['Burigoalini Station', 'Kaikhali Station', 'Dobeki Station'],
    Khulna: ['Nalian Station', 'Patkosta Station', 'Karamjal Station'],
    Chandpai: ['Harbaria Station', 'Joymoni Station', 'Tamulbunia Station'],
    Sarankhola: ['Supati Station', 'Sharankhola Station', 'Kotka Station']
  };
  const [guidesList, setGuidesList] = useState([{
    photo: '👤',
    name: 'Mostafa Kamal',
    email: 'mostafa@guide.com',
    idNumber: 'GD-001',
    phone: '01712345678',
    organization: 'Sundarban Fisheries Ltd',
    status: 'approved' as const
  }, {
    photo: '👤',
    name: 'Rafiq Ahmed',
    email: 'rafiq@guide.com',
    idNumber: 'GD-002',
    phone: '01812345678',
    organization: 'Bay of Bengal Trading Co.',
    status: 'approved' as const
  }, {
    photo: '👤',
    name: 'Salma Khatun',
    email: 'salma@guide.com',
    idNumber: 'GD-003',
    phone: '01912345678',
    organization: 'Khulna Honey Producers',
    status: 'approved' as const
  }, {
    photo: '👤',
    name: 'Babul Hossain',
    email: 'babul@guide.com',
    idNumber: 'GD-004',
    phone: '01612345678',
    organization: 'Mongla Port Services',
    status: 'pending' as const
  }, {
    photo: '👤',
    name: 'Nasreen Akter',
    email: 'nasreen@guide.com',
    idNumber: 'GD-005',
    phone: '01512345678',
    organization: 'Satkhira Wood Industries',
    status: 'approved' as const
  }]);
  const columns = [{
    key: 'photo',
    label: 'Photo',
    render: (value: string) => <div className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center text-xl" data-id="element-993" data-mp="26afesbka1ol0">
          {value}
        </div>
  }, {
    key: 'name',
    label: 'Name'
  }, {
    key: 'email',
    label: 'Email ID'
  }, {
    key: 'idNumber',
    label: 'ID Number'
  }, {
    key: 'phone',
    label: 'Phone Number'
  }, {
    key: 'organization',
    label: 'Organization'
  }, {
    key: 'status',
    label: 'Status',
    render: (value: string) => <StatusBadge status={value as any} data-id="element-994" data-mp="18q5sr9aqgox6" />
  }];
  const filters = [{
    key: 'organization',
    label: 'Organization',
    options: ['Sundarban Fisheries Ltd', 'Bay of Bengal Trading Co.', 'Khulna Honey Producers', 'Mongla Port Services', 'Satkhira Wood Industries']
  }, {
    key: 'status',
    label: 'Status',
    options: ['Approved', 'Pending', 'Rejected']
  }];
  const wizardSteps = [{
    title: 'Personal Info',
    description: 'Enter guide personal information'
  }, {
    title: 'Address & Association',
    description: 'Enter address and organization details'
  }, {
    title: 'Documents',
    description: 'Upload required documents'
  }, {
    title: 'Review & Submit',
    description: 'Review all information before submitting'
  }];
  return <div className="space-y-6" data-id="element-995" data-mp="26dweec0iowcd">
      <div data-id="element-996" data-mp="26ez1s9ymsgnj">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-997" data-mp="26f7d3xf3vdwm">Guide Management</h1>
        <p className="text-sm text-gray-600 mt-1" data-id="element-998" data-mp="3s0pd4zmme8b">
          Manage registered guides and their associations
        </p>
      </div>

      <div className="border-b border-gray-200" data-id="element-999" data-mp="8or2pkk1qvq1">
        <div className="flex gap-4" data-id="element-1000" data-mp="dhbted7nospc">
          <button onClick={() => setActiveTab('list')} className={`px-4 py-2 border-b-2 font-medium text-sm transition-colors ${activeTab === 'list' ? 'border-[#1B5E20] text-[#1B5E20]' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-1001" data-mp="didbv2r04hh3">
            Guide List
          </button>
          <button onClick={() => setActiveTab('add')} className={`px-4 py-2 border-b-2 font-medium text-sm transition-colors ${activeTab === 'add' ? 'border-[#1B5E20] text-[#1B5E20]' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-1002" data-mp="3lyyapqpx5u6h">
            Add Guide
          </button>
        </div>
      </div>

      {activeTab === 'list' && <DataTable columns={columns} data={guidesList} filters={filters} onDataChange={setGuidesList} searchPlaceholder="Search guides..." data-id="element-1003" data-mp="1b397zzix0dw0" />}

      {activeTab === 'add' && <WizardForm steps={wizardSteps} currentStep={currentStep} onStepChange={setCurrentStep} onSubmit={() => {
      if (!formData.fullName || !formData.nid || !formData.organization) {
        alert('Please fill in all required fields.');
        return;
      }
      alert(`Guide ${formData.fullName} registered successfully!`);
      setCurrentStep(0);
      setActiveTab('list');
      setFormData({
        photo: '',
        fullName: '',
        fatherName: '',
        spouseName: '',
        nid: '',
        birthCertNo: '',
        profession: '',
        age: '',
        education: '',
        division: '',
        district: '',
        upazila: '',
        union: '',
        village: '',
        range: '',
        station: '',
        bloodGroup: '',
        organization: '',
        nidAttachment: '',
        birthCertAttachment: '',
        educationAttachment: ''
      });
    }} data-id="element-1004" data-mp="2lx1u9lz94gzc">
          {currentStep === 0 && <div className="space-y-4" data-id="element-1005" data-mp="1lmr27hnug4m0">
              <div className="grid grid-cols-2 gap-4" data-id="element-1006" data-mp="29dwitz1lz0xd">
                <div data-id="element-1007" data-mp="29cd0m2we6fsy">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1008" data-mp="2editc0q1y32h">
                    Photo Upload
                  </label>
                  <input type="file" accept="image/*" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1009" data-mp="1zf8eg32jqkc5" />
                </div>
                <div data-id="element-1010" data-mp="szxvminrwb43">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1011" data-mp="t190klsyfows">
                    Full Name *
                  </label>
                  <input type="text" required value={formData.fullName} onChange={e => setFormData({
              ...formData,
              fullName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1012" data-mp="37a1skd7k5ek8" />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-1013" data-mp="2xaaygcmwt1ko">
                <div data-id="element-1014" data-mp="2xb2m91a9lv0e">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1015" data-mp="2sj2o9edr9c6g">
                    Father's Name
                  </label>
                  <input type="text" value={formData.fatherName} onChange={e => setFormData({
              ...formData,
              fatherName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1016" data-mp="24sf51wye304l" />
                </div>
                <div data-id="element-1017" data-mp="33mp2a9gshexu">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1018" data-mp="33o09kj9g14tp">
                    Spouse Name
                  </label>
                  <input type="text" value={formData.spouseName} onChange={e => setFormData({
              ...formData,
              spouseName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1019" data-mp="3dkmqwy2k9dqz" />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-1020" data-mp="a9dnfgoqzxzr">
                <div data-id="element-1021" data-mp="aayfmznlb4ug">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1022" data-mp="a7ano4xsmqhu">
                    NID Number *
                  </label>
                  <input type="text" required value={formData.nid} onChange={e => setFormData({
              ...formData,
              nid: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1023" data-mp="apj1kporhej" />
                </div>
                <div data-id="element-1024" data-mp="f7oxnsiygaii">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1025" data-mp="f8hthygdlflv">
                    Birth Certificate No.
                  </label>
                  <input type="text" value={formData.birthCertNo} onChange={e => setFormData({
              ...formData,
              birthCertNo: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1026" data-mp="16ze7j2e69qaq" />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4" data-id="element-1027" data-mp="1i744591c33lf">
                <div data-id="element-1028" data-mp="1i5knhhbrmqj4">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1029" data-mp="1d92komzzx29f">
                    Profession
                  </label>
                  <input type="text" value={formData.profession} onChange={e => setFormData({
              ...formData,
              profession: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1030" data-mp="1qyxs3gj6zgl1" />
                </div>
                <div data-id="element-1031" data-mp="2kj5iaq9omh1i">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1032" data-mp="2kjfcyr5o9cdj">
                    Age
                  </label>
                  <input type="number" value={formData.age} onChange={e => setFormData({
              ...formData,
              age: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1033" data-mp="2am0vqpbxcjk6" />
                </div>
                <div data-id="element-1034" data-mp="1rtf7aq3cjv9m">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1035" data-mp="1dw0b92il8p8o">
                    Education
                  </label>
                  <input type="text" value={formData.education} onChange={e => setFormData({
              ...formData,
              education: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1036" data-mp="1hw236jyiu4ar" />
                </div>
              </div>
            </div>}

          {currentStep === 1 && <div className="space-y-4" data-id="element-1037" data-mp="2dw4stkyvv53">
              <div className="grid grid-cols-2 gap-4" data-id="element-1038" data-mp="2exeatmc49kp">
                <div data-id="element-1039" data-mp="3tk5uaygpe241">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1040" data-mp="3tjnnj7wf05hv">
                    Division
                  </label>
                  <select value={formData.division} onChange={e => setFormData({
              ...formData,
              division: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1041" data-mp="3pl6hkroqd121">
                    <option value="" data-id="element-1042" data-mp="12m2gvhl7bi1s">Select Division</option>
                    <option value="Khulna" data-id="element-1043" data-mp="12kho9xig696k">Khulna</option>
                    <option value="Barisal" data-id="element-1044" data-mp="17eceljsk5mem">Barisal</option>
                    <option value="Dhaka" data-id="element-1045" data-mp="1ccdy25twbnqm">Dhaka</option>
                    <option value="Chattogram" data-id="element-1046" data-mp="1cbvt8kt64173">Chattogram</option>
                    <option value="Rajshahi" data-id="element-1047" data-mp="1hap8ois0m29w">Rajshahi</option>
                    <option value="Rangpur" data-id="element-1048" data-mp="1hdbf2f366bqj">Rangpur</option>
                    <option value="Sylhet" data-id="element-1049" data-mp="1ledfgz8totu3">Sylhet</option>
                    <option value="Mymensingh" data-id="element-1050" data-mp="1qbwva3l65eo5">Mymensingh</option>
                  </select>
                </div>
                <div data-id="element-1051" data-mp="3n4ylo4lwcnvn">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1052" data-mp="3n5qjzn6vozpm">
                    District
                  </label>
                  <select value={formData.district} onChange={e => setFormData({
              ...formData,
              district: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1053" data-mp="3s5cxlxqmchyy">
                    <option value="" data-id="element-1054" data-mp="2e2c7xjtlvw2c">Select District</option>
                    <option value="Satkhira" data-id="element-1055" data-mp="2e0r93i09dqyo">Satkhira</option>
                    <option value="Khulna" data-id="element-1056" data-mp="2953mnad5vbwv">Khulna</option>
                    <option value="Bagerhat" data-id="element-1057" data-mp="2nsey7c9cevwz">Bagerhat</option>
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-1058" data-mp="2j0x8xlgomjru">
                <div data-id="element-1059" data-mp="2j03x462v942u">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1060" data-mp="1vbuh5ksc3ajm">
                    Upazila
                  </label>
                  <select value={formData.upazila} onChange={e => setFormData({
              ...formData,
              upazila: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1061" data-mp="1qchscuhwjtee">
                    <option value="" data-id="element-1062" data-mp="tt1xm2mqxfq">Select Upazila</option>
                    <option value="Shyamnagar" data-id="element-1063" data-mp="on1grarpat6w">Shyamnagar</option>
                    <option value="Koyra" data-id="element-1064" data-mp="tlctbt9drhst">Koyra</option>
                    <option value="Dacope" data-id="element-1065" data-mp="tk1mfkkn1txh">Dacope</option>
                    <option value="Mongla" data-id="element-1066" data-mp="fltnx87yekk7">Mongla</option>
                    <option value="Sarankhola" data-id="element-1067" data-mp="fned0ibi1bao">Sarankhola</option>
                  </select>
                </div>
                <div data-id="element-1068" data-mp="30biy37xppi6k">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1069" data-mp="30b13sgum1e1a">
                    Union
                  </label>
                  <select value={formData.union} onChange={e => setFormData({
              ...formData,
              union: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1070" data-mp="34e799m9wf16p">
                    <option value="" data-id="element-1071" data-mp="s3nv6u88oquj">Select Union</option>
                    <option value="Burigoalini" data-id="element-1072" data-mp="s58qim2dodtg">Burigoalini</option>
                    <option value="Gabura" data-id="element-1073" data-mp="n4baaf0xhtul">Gabura</option>
                    <option value="Munshiganj" data-id="element-1074" data-mp="n6nmscnx3c09">Munshiganj</option>
                    <option value="Koyra" data-id="element-1075" data-mp="i69gaz1ysa4c">Koyra</option>
                    <option value="Dacope" data-id="element-1076" data-mp="d6n14k2ksjsw">Dacope</option>
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-1077" data-mp="2cjr3gkygj4yu">
                <div data-id="element-1078" data-mp="2ch4ymt2yb3kb">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1079" data-mp="27ko2pcpifkwo">
                    Village
                  </label>
                  <select value={formData.village} onChange={e => setFormData({
              ...formData,
              village: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1080" data-mp="2g0nbs335vtxg">
                    <option value="" data-id="element-1081" data-mp="1x4x7283ugjfv">Select Village</option>
                    <option value="Munshiganj" data-id="element-1082" data-mp="214xkpqj4cqlv">Munshiganj</option>
                    <option value="Gabura" data-id="element-1083" data-mp="262pobht4m15w">Gabura</option>
                    <option value="Shyamnagar" data-id="element-1084" data-mp="261xuabf6gbhq">Shyamnagar</option>
                    <option value="Koyra" data-id="element-1085" data-mp="2b3db1rabnvub">Koyra</option>
                    <option value="Dacope" data-id="element-1086" data-mp="3hiecudm1388t">Dacope</option>
                  </select>
                </div>
                <div data-id="element-1087" data-mp="3mhimf5cv77zo">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1088" data-mp="3mgpmoocbpir1">
                    Range
                  </label>
                  <select value={formData.range} onChange={e => setFormData({
              ...formData,
              range: e.target.value,
              station: ''
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1089" data-mp="bgovm3mybl0q">
                    <option value="" data-id="element-1090" data-mp="q5uol9v74f06">Select Range</option>
                    <option value="Satkhira" data-id="element-1091" data-mp="q7e4gzcxwo1f">Satkhira</option>
                    <option value="Khulna" data-id="element-1092" data-mp="143j8aedj1g3n">Khulna</option>
                    <option value="Chandpai" data-id="element-1093" data-mp="z5zokyy28b4b">Chandpai</option>
                    <option value="Sarankhola" data-id="element-1094" data-mp="z3n6mlsay0r9">Sarankhola</option>
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4" data-id="element-1095" data-mp="30xcqdf4qe2w5">
                <div data-id="element-1096" data-mp="30yxjd0beddrw">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1097" data-mp="30zh40osfmg9m">
                    Station
                  </label>
                  <select value={formData.station} onChange={e => setFormData({
              ...formData,
              station: e.target.value
            })} disabled={!formData.range} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20] disabled:bg-gray-100 disabled:text-gray-400" data-id="element-1098" data-mp="1leerq0mmx7tv">
                    <option value="" data-id="element-1099" data-mp="op7dzes9c30i">
                      {formData.range ? 'Select Station' : 'Select Range first'}
                    </option>
                    {formData.range && stationsByRange[formData.range]?.map(station => <option key={station} value={station} data-id="element-1100" data-mp="2n40n8w8f10yg">
                          {station}
                        </option>)}
                  </select>
                </div>
                <div data-id="element-1101" data-mp="1c1moykgf8p8a">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1102" data-mp="1c1wey81guwdz">
                    Blood Group
                  </label>
                  <select value={formData.bloodGroup} onChange={e => setFormData({
              ...formData,
              bloodGroup: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1103" data-mp="xadothew7lgw">
                    <option value="" data-id="element-1104" data-mp="1l0zwv8owd5qw">Select Blood Group</option>
                    <option value="A+" data-id="element-1105" data-mp="1l3m2h2s89b6h">A+</option>
                    <option value="A-" data-id="element-1106" data-mp="4mrnkft50sx7">A-</option>
                    <option value="B+" data-id="element-1107" data-mp="9mme2i903ghq">B+</option>
                    <option value="B-" data-id="element-1108" data-mp="9nfdey5mr3pu">B-</option>
                    <option value="AB+" data-id="element-1109" data-mp="2nuex75tz2136">AB+</option>
                    <option value="AB-" data-id="element-1110" data-mp="2nt3r2zd20h8w">AB-</option>
                    <option value="O+" data-id="element-1111" data-mp="2ivam29nhlta7">O+</option>
                    <option value="O-" data-id="element-1112" data-mp="2iusjkva8eitu">O-</option>
                  </select>
                </div>
                <div data-id="element-1113" data-mp="2wts53u2g6hls">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1114" data-mp="2wsz99o511cif">
                    Organization *
                  </label>
                  <select required value={formData.organization} onChange={e => setFormData({
              ...formData,
              organization: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1115" data-mp="253e0kogbqhms">
                    <option value="" data-id="element-1116" data-mp="1heb96ovw1af3">Select Organization</option>
                    <option value="Sundarban Fisheries Ltd" data-id="element-1117" data-mp="1hdte3vkyp28r">
                      Sundarban Fisheries Ltd
                    </option>
                    <option value="Bay of Bengal Trading Co." data-id="element-1118" data-mp="3li62ogpv4ph7">
                      Bay of Bengal Trading Co.
                    </option>
                    <option value="Khulna Honey Producers" data-id="element-1119" data-mp="3q9xmm8eijwyd">
                      Khulna Honey Producers
                    </option>
                    <option value="Mongla Port Services" data-id="element-1120" data-mp="3va233yff8rol">
                      Mongla Port Services
                    </option>
                    <option value="Satkhira Wood Industries" data-id="element-1121" data-mp="32j1xjj1fzfut">
                      Satkhira Wood Industries
                    </option>
                  </select>
                </div>
              </div>
            </div>}

          {currentStep === 2 && <div className="space-y-4" data-id="element-1122" data-mp="3cfeowa9ilhme">
              <div data-id="element-1123" data-mp="msp4rojscx3n">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1124" data-mp="mr4c64h17o8f">
                  NID Copy *
                </label>
                <input type="file" accept="image/*,application/pdf" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1125" data-mp="rtd6p59jyycn" />
              </div>
              <div data-id="element-1126" data-mp="22i6sxkzm6t6g">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1127" data-mp="22hn91yqelups">
                  Birth Certificate Copy
                </label>
                <input type="file" accept="image/*,application/pdf" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1128" data-mp="1sltru21qpd1o" />
              </div>
              <div data-id="element-1129" data-mp="1eliz0tgvdodv">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1130" data-mp="1em2hcbafmesf">
                  Education Certificate
                </label>
                <input type="file" accept="image/*,application/pdf" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1131" data-mp="3dy50fkf5975k" />
              </div>
            </div>}

          {currentStep === 3 && <div className="space-y-6" data-id="element-1132" data-mp="1wo8931zvvyp9">
              <div className="bg-gray-50 rounded-lg p-4" data-id="element-1133" data-mp="1wn6jztm19boj">
                <div className="flex items-center justify-between mb-3" data-id="element-1134" data-mp="21msx831v2rxc">
                  <h4 className="font-semibold text-gray-900" data-id="element-1135" data-mp="21p5oj6tieen2">
                    Personal Information
                  </h4>
                  <button onClick={() => setCurrentStep(0)} className="text-sm text-[#1B5E20] hover:underline" data-id="element-1136" data-mp="1romz7wj6e5xr">
                    Edit
                  </button>
                </div>
                <div className="grid grid-cols-2 gap-3 text-sm" data-id="element-1137" data-mp="1ix34rmlkmi8l">
                  <div data-id="element-1138" data-mp="13ysobkif2rg5">
                    <span className="text-gray-600" data-id="element-1139" data-mp="140lukyp4b9nm">Name:</span>{' '}
                    <span className="font-medium" data-id="element-1140" data-mp="18yx4f9fexk5u">
                      {formData.fullName || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1141" data-mp="peoi3jaedlvw">
                    <span className="text-gray-600" data-id="element-1142" data-mp="lb9zqlyzktfa">NID:</span>{' '}
                    <span className="font-medium" data-id="element-1143" data-mp="ld38q7x2npqg">
                      {formData.nid || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1144" data-mp="ubf5kroj7jrc">
                    <span className="text-gray-600" data-id="element-1145" data-mp="ua3tm4kxn5p5">Profession:</span>{' '}
                    <span className="font-medium" data-id="element-1146" data-mp="18aofj9m59hmv">
                      {formData.profession || 'Not provided'}
                    </span>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 rounded-lg p-4" data-id="element-1147" data-mp="1i07x8by4f5g5">
                <div className="flex items-center justify-between mb-3" data-id="element-1148" data-mp="1d26btkd82u1i">
                  <h4 className="font-semibold text-gray-900" data-id="element-1149" data-mp="1d2y6msyzwnqq">
                    Address & Association
                  </h4>
                  <button onClick={() => setCurrentStep(1)} className="text-sm text-[#1B5E20] hover:underline" data-id="element-1150" data-mp="1n0cazu7n9m2o">
                    Edit
                  </button>
                </div>
                <div className="grid grid-cols-2 gap-3 text-sm" data-id="element-1151" data-mp="1z3f1atamgdvv">
                  <div data-id="element-1152" data-mp="24186bj06v1uk">
                    <span className="text-gray-600" data-id="element-1153" data-mp="240oxcrsinnso">Division:</span>{' '}
                    <span className="font-medium" data-id="element-1154" data-mp="28sylc2a2mdsb">
                      {formData.division || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1155" data-mp="2dtmb6kmkcoky">
                    <span className="text-gray-600" data-id="element-1156" data-mp="2ht4y1lxy39qf">District:</span>{' '}
                    <span className="font-medium" data-id="element-1157" data-mp="2hv7vus5ca75p">
                      {formData.district || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1158" data-mp="2rq9ldp3j1b8t">
                    <span className="text-gray-600" data-id="element-1159" data-mp="2rqjbdcokniei">Upazila:</span>{' '}
                    <span className="font-medium" data-id="element-1160" data-mp="sf8guuf1hni5">
                      {formData.upazila || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1161" data-mp="ptsc3ps6uar9">
                    <span className="text-gray-600" data-id="element-1162" data-mp="pu0o7fghlc1e">Union:</span>{' '}
                    <span className="font-medium" data-id="element-1163" data-mp="l326cbfuo5w1">
                      {formData.union || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1164" data-mp="g4h4k7ky9e5h">
                    <span className="text-gray-600" data-id="element-1165" data-mp="g1v04gtcverh">Village:</span>{' '}
                    <span className="font-medium" data-id="element-1166" data-mp="b67bc2iscnmi">
                      {formData.village || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1167" data-mp="13t0cun401qxk">
                    <span className="text-gray-600" data-id="element-1168" data-mp="13ul8kg21vfx0">Range:</span>{' '}
                    <span className="font-medium" data-id="element-1169" data-mp="yu6yytksvxwv">
                      {formData.range || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1170" data-mp="tv4607i3hi59">
                    <span className="text-gray-600" data-id="element-1171" data-mp="3jko7gbvjj7d7">Station:</span>{' '}
                    <span className="font-medium" data-id="element-1172" data-mp="3jlzdkicgkr7h">
                      {formData.station || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1173" data-mp="842yplcrixvf">
                    <span className="text-gray-600" data-id="element-1174" data-mp="82rlyw1cafs6">Organization:</span>{' '}
                    <span className="font-medium" data-id="element-1175" data-mp="d4gykg47n1id">
                      {formData.organization || 'Not provided'}
                    </span>
                  </div>
                </div>
              </div>
            </div>}
        </WizardForm>}
    </div>;
}